import React from 'react'
import {Trans, useTranslation} from 'react-i18next'
import classNames from 'classnames'
import {Typography} from 'antd'
import {useScreenType, useLocalStorageBoolean} from '@/hooks'
import {IS_SIDER_COLLAPSED_KEY} from '@/constants'
import CustomerInsightsImg from '~/assets/img/digital-receipts/customer_insights.svg'

import styles from './styles.scss'

export const CustomerInsights = () => {
    const {t} = useTranslation()
    const isCollapsed = useLocalStorageBoolean(IS_SIDER_COLLAPSED_KEY)
    const {isTablet} = useScreenType()

    return (
        <section className={styles.container}>
            <div
                className={classNames(styles.content, {
                    [styles.notCollapsedSiderView]: !isCollapsed && isTablet
                })}
            >
                <div className={styles.img}>
                    <img src={CustomerInsightsImg} alt={t('CustomerInsights.alt')} />
                </div>
                <div className={styles.text}>
                    <div>
                        <Typography.Title className={styles.title}>
                            <Trans
                                i18nKey='CustomerInsights.title'
                                components={{
                                    green: <span className={styles.green} />
                                }}
                            />
                        </Typography.Title>
                        <Typography.Paragraph>
                            {t('CustomerInsights.description')}
                        </Typography.Paragraph>

                        <ul className={styles.list}>
                            <li>{t('CustomerInsights.item1')}</li>
                            <li>{t('CustomerInsights.item2')}</li>
                            <li>{t('CustomerInsights.item3')}</li>
                            <li>{t('CustomerInsights.item4')}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}
